/**
 * Mark — framework-agnostic Salonomy brand lockup (WS-11).
 *
 * A plain `<img>` with the canonical aspect ratio baked in. Deliberately imports NOTHING from
 * `next/*` (unlike apps/marketing's Brandmark, which uses next/link) so it is safe to share into
 * the Vite + React-Router console build — a next import would poison that bundle.
 *
 * Each app passes its OWN asset path, because the served location differs per app:
 *   - console (Vite SPA): `${import.meta.env.BASE_URL}salonomy-logo.svg`  (served at /salonomy-logo.svg)
 *   - marketing (Next):   `/brand/salonomy-logo.svg`
 * The default `src` is the marketing path; the console must pass its BASE_URL-prefixed path.
 */

// Intrinsic aspect ratio of the canonical lockup (viewBox 240.3169 x 166.7872).
const RATIO = 240.3169 / 166.7872;

export interface MarkProps {
  /** Image source. Each app passes its own served path (see module note). */
  src?: string;
  /** Rendered height in px; width is derived from the canonical ratio. */
  height?: number;
  className?: string;
  /** Accessible alt text. */
  alt?: string;
}

export function Mark({
  src = '/brand/salonomy-logo.svg',
  height = 40,
  className,
  alt = 'Salonomy',
}: MarkProps) {
  return (
    <img
      src={src}
      alt={alt}
      height={height}
      width={Math.round(height * RATIO)}
      className={className}
      style={{ display: 'block', height, width: 'auto' }}
    />
  );
}
